import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { setCloudReportFilters } from '../../Reports/reports.slice'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCloudReportFilters } from '../../Reports/reports.selectors'

const CheckBoxHeaderFilter = ({ column, specificFilters }) => {
	const dispatch = useDispatch()
	const reportFilters = useSelector(selectCloudReportFilters)

	if (specificFilters == null || specificFilters.length < 1) return null

	return (
		<>
			{specificFilters &&
				specificFilters.map((filter) => (
					<div key={filter} className='flex items-center gap-2 py-1'>
						<Switch
							id={`${column.dataField}-${filter}`}
							checked={reportFilters[`${column.dataField}`]?.includes(filter)}
							onCheckedChange={() => {
								dispatch(
									setCloudReportFilters({
										...reportFilters,
										[`${column.dataField}`]: reportFilters[`${column.dataField}`]?.includes(filter)
											? reportFilters[`${column.dataField}`].filter((item) => item !== filter)
											: reportFilters[`${column.dataField}`]?.length > 0
												? [...reportFilters[`${column.dataField}`], filter]
												: [filter],
									})
								)
							}}
						/>
						<Label htmlFor={`${column.dataField}-${filter}`}>{filter}</Label>
					</div>
				))}
		</>
	)
}

export default CheckBoxHeaderFilter
